var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col w-screen h-screen bg-primary-300"},[_c('malta-header'),_c('div',{staticClass:"flex-1 overflow-hidden m-4 mt-6 mb-6"},[_c('router-view')],1),_c('malta-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }